/**
 * 订单备注展示：去掉 PKGID 等内部编码，保留可读说明（赠送配送 / 来源订单号等）。
 */
export function formatOrderRemarkDisplay(remark?: string | null): string {
  let s = String(remark || '').trim()
  if (!s) return ''

  // 优先只展示用户主动填写的备注（后端会拼「用户备注:xxx」）
  const userMatch = s.match(/用户备注[:：]\s*(.+)$/)
  if (userMatch) {
    return String(userMatch[1] || '').trim()
  }

  const isAdminGift = /^赠送配送/.test(s)
  const isPkgDelivery =
    s.indexOf('套餐额度抵扣') >= 0 ||
    s.indexOf('套餐单:') >= 0 ||
    s.indexOf('套餐单：') >= 0 ||
    s.indexOf('PKGID:') >= 0 ||
    /送\d+桶/.test(s)
  const sourceNo =
    (s.match(/套餐单[:：]\s*([^；;\s]+)/) ||
      s.match(/原订单[:：]\s*([^；;\s]+)/) ||
      [])[1] || ''

  s = s
    .replace(/送\d+桶[；;]?/g, '')
    .replace(/特惠套餐:[^；;]*/g, '')
    .replace(/实惠套餐:[^；;]*/g, '')
    .replace(/特惠:[^；;]*/g, '')
    .replace(/实惠:[^；;]*/g, '')
    .replace(/购物车套餐[；;]?/g, '')
    .replace(/赠品本次送[；;]?/g, '')
    .replace(/赠品以后送[；;]?/g, '')
    .replace(/套餐额度抵扣配送[；;]?/g, '')
    .replace(/赠送配送[；;：:]*/g, '')
    .replace(/[；;]?PKGID:\d+/gi, '')
    .replace(/[；;]?套餐单[:：][^；;\s]*/g, '')
    .replace(/[；;]?原订单[:：][^；;\s]*/g, '')
    .replace(/[；;]?B\d+/g, '')
    .replace(/(?:^|[；;\s])\d+桶(?=[；;\s]|$)/g, '')
    .replace(/无空桶押\d+个×\d+元/g, '')
    .replace(/含单品配送[；;]?/g, '')
    .replace(/联单货:\d+[；;]?/g, '')
    .replace(/联单购:PKGID:\d+[；;]?/g, '')
    .replace(/[；;]+/g, '；')
    .replace(/^[；;\s]+|[；;\s]+$/g, '')
    .trim()

  if (s) return s

  if (isAdminGift) {
    return sourceNo ? `赠送配送；来源订单：${sourceNo}` : '赠送配送'
  }
  if (isPkgDelivery) {
    return sourceNo ? `套餐配送；来源订单：${sourceNo}` : '套餐配送'
  }
  return ''
}

export function isPackageImmediateDeliveryRemark(remark?: string | null): boolean {
  const s = String(remark || '')
  return (
    s.indexOf('套餐额度抵扣') >= 0 ||
    s.indexOf('PKGID:') >= 0 ||
    s.indexOf('套餐单:') >= 0 ||
    /送\d+桶/.test(s)
  )
}
